import { Pagination } from 'antd';
import { ListData } from 'comps/ShopProListPC';
import jsurl from 'jsurl';
import { useRouter } from 'next/router';
import AreaEmptyData from 'comps/AreaEmptyData';
import { FullProductCardItem } from '../components';
import FullProductList from './FullProductList';
import { ShowType } from 'comps/ListRuleBar';

type SearchListContentProps = {
  listData: ListData;
  updateSearch: Function;
  emptyText?: string;
};
export default function SearchListContent({ listData, updateSearch }: SearchListContentProps) {
  const router = useRouter();
  const params = jsurl.parse(router.query.params);
  const showType: ShowType = params?.showType ?? ShowType.GIRD;
  function onPageChange(pageNo, pageSize) {
    updateSearch({ pageNo, pageSize });
  }

  return (
    <>
      {listData.datas?.length ? (
        <>
          {showType === ShowType.GIRD ? (
            <div className="goods-grid clearfix">
              {listData.datas?.map((item, index) => (
                <FullProductCardItem data={item} key={index}>
                  {/* <ProductPrice data={item} /> */}
                </FullProductCardItem>
              ))}
            </div>
          ) : (
            <FullProductList listData={listData} />
          )}
          <div className="pagination-wrap">
            <Pagination
              pageSizeOptions={['10', '20', '30', '50', '100']}
              showQuickJumper
              current={listData.pageNo}
              pageSize={listData.pageSize}
              total={listData.total}
              onChange={onPageChange}
            />
          </div>
        </>
      ) : (
        <AreaEmptyData areaLevel={3} height="400px" />
      )}
      <style jsx>{`
        .goods-grid {
          margin-right: -20px;
          line-height: 1.4166666666666667;
        }
        .pagination-wrap {
          text-align: right;
          margin-bottom: 40px;
        }
      `}</style>
    </>
  );
}
